﻿import React, { Fragment, useState, useEffect } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom'
import 'pages/risk/risk.css';

import { VerticalLinkGroup } from 'components/navigation';
import { PageRestricted } from 'pages/errors/page-restricted';
import { UserAccess } from 'components/user-access';
import { RiskGeneralSettings } from './RiskGeneralSettings';
import { RiskEventSettings } from './RiskEventSettings';
import { RiskBandSettings } from './RiskBandSettings';
import { RiskCarryOverSettings } from './RiskCarryOverSettings';
import { RiskService } from 'services/RiskService';
import { RiskSettingsHistory } from 'pages/risk/settings/RiskSettingsHistory';

export function RiskSettings() {

    const [routes, setRoutes] = useState([]);
    const [riskStarted, setRiskStarted] = useState(false);
    const [riskEnabled, setRiskEnabled] = useState(false);

    useEffect(init, []);

    function init() {
        RiskService.getSettings().then(function (generalSettings) {
            setRiskStarted(generalSettings.riskInProgress);
            setRiskEnabled(generalSettings.enabled);
        });
    }

    function onEnabledChange(enabled) {
        setRiskEnabled(enabled);
    }

    useEffect(function () {

        var menuRoutes = [{ location: "/risk-settings/general", title: "General Settings" }];

        if (riskEnabled) {
            menuRoutes.push(
                { location: "/risk-settings/events/employee", title: "Employee Event Settings" },
                { location: "/risk-settings/events/asset", title: "Asset Event Settings" },
                { location: "/risk-settings/events/organisation", title: "Organisation Event Settings" },
                { location: "/risk-settings/bands", title: "Band Settings" },
                { location: "/risk-settings/carry-over", title: "Points Carry-Over Settings" }
            );
        }

        menuRoutes.push(
            { location: "/risk-settings/history", title: "History" }
        )

        setRoutes(menuRoutes);

    }, [riskEnabled]);

    return (
        <UserAccess perform={["Risk:Manage"]}
            yes={() => (
                <Fragment>
                    <div className="row">
                        <h1>Risk Settings</h1>
                        <div className="intro-text">
                            <p>In this section you can configure your risk settings to create a Risk Score that suits your organisation.</p>
                        </div>
                    </div>

                    <div className="layout-cols">
                        <div className="col side-col">
                            <div className="row">
                                <VerticalLinkGroup links={routes} exactRouteMatch={false}></VerticalLinkGroup>
                            </div>
                        </div>
                        <div className="col content-col">
                            <Routes>
                                <Route path="general" element={<RiskGeneralSettings onEnabledChange={onEnabledChange} />} />
                                <Route path="" element={<Navigate to="/risk-settings/general" replace />} />
                                <Route path="bands" element={<RiskBandSettings riskStarted={riskStarted} />} />
                                <Route path="carry-over" element={<RiskCarryOverSettings riskStarted={riskStarted} />} />
                                <Route path="events/employee" element={<RiskEventSettings areaId={1} areaName="Employee" riskStarted={riskStarted} />} />
                                <Route path="events/asset" element={<RiskEventSettings areaId={2} areaName="Asset" riskStarted={riskStarted} />} />
                                <Route path="events/organisation" element={<RiskEventSettings areaId={3} areaName="Organisation" riskStarted={riskStarted} />} />
                                <Route path="history" element={<RiskSettingsHistory />} />
                            </Routes>
                        </div>
                        


                    </div>
                </Fragment>
            )}
            no={() => (
                <PageRestricted />
            )}
        />

    );

}